import type { AutoDormCheckGrantInput, Paginated } from "./types";

export function courseGrabGrantInput(
  input: AutoDormCheckGrantInput,
): CourseGrabGrantInput {
  if (input.quotaKind !== "count" || input.scope === "paid_plan")
    throw new Error("请选择支持的次数发放范围");
  if (
    !Number.isSafeInteger(input.quotaAmount) ||
    input.quotaAmount < 1 ||
    input.quotaAmount > 1000
  )
    throw new Error("请输入 1 到 1000 的整数次数");
  return {
    scope: input.scope,
    quotaAmount: input.quotaAmount,
    includeFuture: input.scope !== "selected_users" && input.includeFuture,
    ...(input.scope === "selected_users"
      ? { selectedUserIds: input.selectedUserIds }
      : {}),
    reason: "管理员发放抢课次数",
  };
}
export interface CourseGrabUser {
  userId: string;
  account: string;
  studentNumber?: string | null;
  displayName: string;
  className: string | null;
  createdAt: string;
  purchased: boolean;
  balance: { remaining: number; reserved: number; consumed: number };
  recentTasks: Array<{
    id: string;
    searchKeywords: string[];
    scheduledAt: string;
    state: string;
    enabled: boolean;
    resultCode: string | null;
  }>;
}
export type CourseGrabUsers = Paginated<CourseGrabUser> & {
  facets: { all: number; paid: number; quota: number };
};
export interface CourseGrabGrantInput {
  scope: "all_users" | "selected_users" | "paid_any";
  quotaAmount: number;
  includeFuture: boolean;
  selectedUserIds?: string[];
  reason: string;
}
export interface CourseGrabAdjustmentInput {
  operation: "add" | "deduct" | "set";
  quotaAmount: number;
  reason: string;
}
export interface CourseGrabChange {
  id: string;
  recipientCount: number;
  totalUses: number;
  includeFuture?: boolean;
}
export const courseGrabTaskLabels: Record<string, string> = {
  pending: "等待抢课",
  warming: "准备中",
  retrying: "等待重试",
  checking: "抢课中",
  paused: "已暂停",
  expired: "时间已过",
  submitting: "选课中",
  uncertain: "结果确认中",
  succeeded: "已抢到",
  failed: "未抢到",
  disabled: "已关闭",
};
export function courseGrabTaskTone(state: string): string {
  if (state === "retrying") return "pending";
  if (["succeeded", "failed", "pending"].includes(state)) return state;
  return ["warming", "checking", "submitting", "uncertain"].includes(state)
    ? "running"
    : "skipped";
}
